<template>
  <div class="mobile-container">
    <page-header>{{'我的同行人' | dealLanguage('Traveling Companion')}}</page-header>
    <div class="wrap">
      <div class="view-title">
        <div class="title">{{'我的同行人' | dealLanguage('Traveling Companion')}}</div>
        <div class="line"></div>
        <div class="button" @click="addCompanions">{{'添加同行人' | dealLanguage('Add')}}</div>
      </div>
      <table>
        <thead>
          <tr v-if="language == 'zh'">
            <th>{{'姓名、手机' | dealLanguage('Name')}}</th>
            <th>{{'公司、部门' | dealLanguage('Company')}}</th>
            <th>{{'职位' | dealLanguage('Position')}}</th>
            <th></th>
          </tr>
          <tr v-else>
            <th>Name<br>Phone</th>
            <th>Company<br>Department</th>
            <th>Position</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <van-list
              v-model="loading"
              :finished="finished"
              @load="onLoad"
            >
              <van-cell v-for="(item, index) in data" :key="index">
                <div class="th-div">
                  <p>{{item.name}}</p>
                  <p>+{{item.mobileAreaCode}}{{item.mobile}}</p>
                </div>
                <div class="th-div">
                  <p>{{item.compName}}</p>
                  <p>{{item.department}}</p>
                </div>
                <div class="th-div">
                  <p>{{item.title}}</p>
                </div>
                <div class="th-div">
                  <p class="th-button" @click="delPartner(item.id)">{{'删除' | dealLanguage('Delete')}}</p>
                </div>
              </van-cell>
            </van-list>
        </tbody>

      </table>
    </div>
    <van-popup v-model="show" round position="bottom" :style="{ height: 'fit-content' }">
      <div class="pop-content">
        <div class="high-line"></div>
        <van-form @submit="onSubmit">
          <van-field
            v-model="username"
            name="用户名"
            label="用户名"
            placeholder="用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
          />
          <van-field
            v-model="password"
            type="password"
            name="密码"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
          <div class="form-button">
            <van-button plain type="info" color="#C8161D">取消</van-button>
            <van-button type="info" native-type="submit" color="#C8161D">提交</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import { getPartnerList, modifyPartner, delPartner } from '@/service/vbef'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '我的同行人' : 'Traveling Companion', 
    }
  },
  inject: ['wxShare'],
  data () {
    return {
      data: [],
      show: false,
      username: '',
      password: '',
      loading: false,
      finished: true,
      page: 1,
      size: 20
    }
  },

  components: {
    PageHeader,
  },

  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
      vbef_path: (state) => state.vbef_path,
      static_img_url: (state) => state.static_img_url,
    })
  },

  created() {
    this.getPartnerList()
  },

  mounted() {
    this.wxShare({
      title: filter.dealLanguage('我的同行人-CSGCT', 'Traveling Companion-CSGCT'),
      linkurl: this.vbef_path + '/companions',
      
    })
  },

  methods: {
    addCompanions() {
      this.$router.push({
        name: 'addCompanions',
      })
    },
    onSubmit() {

    },
    async getPartnerList(more = 0) {
      this.loading = true
      let res = await getPartnerList({
        page: this.page,
        size: this.size
      })
      if(res.code == 0) {
        if(more == 0) {
          this.$set(this, 'data', res.data.partner)
        } else {
          this.data = [...this.data, ...res.data.partner]
        }
        this.data.length >= res.data.count ? (this.finished = true) : (this.finished = false)
      }
      this.loading = false
    },
    async delPartner(id) {
      let res = await delPartner({
        id: id
      })
      if(res.code == 0) {
        this.getPartnerList()
      } else {
        this.$Message.error(this.language == 'zh' ? '删除失败' : 'Delete failed')
      }
    },
    onLoad() {
      this.page++
      this.getPartnerList(1)
    }
  }
}

</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
@import '~styles/ticket-item-m.styl'
>>>.van-overlay
  background-color: rgba(0, 0, 0, .4);
>>>.van-popup--bottom.van-popup--round
  border-radius .2rem .2rem 0 0
.wrap
  padding .2rem .4rem
  .button
    width 1.9rem
    height .6rem
    background: #C8161D
    border-radius: .1rem
    border 1px solid #C8161D
    transition all .5s
    margin-left: .15rem
    font-size: .26rem
    color: #FFFFFF;
    line-height: .6rem
    text-align: center
    &:hover
      background-color #E24147
      border-color #E24147
  table
    width 100%
    text-align: left
    thead
      tr
        display: flex
        justify-content: space-between
        // height: .8rem !important
        background: #FFFAF5
        padding 0.22rem .12rem
        align-items: center
        th
          font-weight: 400;
          font-size: .26rem
          color: #333333
          &:nth-child(1)
            flex 0 0 38%
          &:nth-child(2)
            flex 0 0 38%
          &:nth-child(3)
            flex 0 0 12%
          &:nth-child(4)
            flex 0 0 12%
    >>>.van-list
      .van-cell
        padding 0 0.12rem
        .van-cell__value 
          display: flex
          justify-content: space-between
          align-items: center
          height 1.24rem !important
          border-bottom .01rem solid #F3F3F3
          .th-div
            font-size: .24rem
            color: #666666;
            text-align: left
            &:nth-child(1)
              flex 0 0 38%
            &:nth-child(2)
              flex 0 0 38%
            &:nth-child(3)
              flex 0 0 12%
            &:nth-child(4)
              flex 0 0 12%
            .th-button
              color: #1572E7;
>>>.van-popup
  .pop-content
    padding .4rem .4rem .96rem
    .high-line
      width .7rem
      height: .1rem
      background: #FFF4EB
      margin 0 auto
    .van-form
      .van-cell
        flex-wrap: wrap
        padding .1rem 0
        .van-field__label
          flex 0 0 100%
          color #666
        .van-cell__value
          background: #f9f9f9
          margin-top .1rem
          .van-field__body
            height: .88rem
            padding .24rem .2rem
            .van-field__control
              color #333
              font-size .28rem
    .form-button
      display: flex
      justify-content: space-between
      .van-button
        border-radius: .22rem
      .van-button--normal
        padding 0
      .van-button--block
        width unset
      .van-button__content
        width 3.2rem
        height .94rem
</style>